module.exports = __webpack_public_path__ + "15e1ac8cbacc2efdf1ac2677de48a253.png";